import { render } from "./CommandeView.vue?vue&type=template&id=44344d82"
import script from "./CommandeView.vue?vue&type=script&lang=js"
export * from "./CommandeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__